import React, { useState } from "react";
import { Wheel } from "react-custom-roulette";
import { Link } from "react-router-dom";
import { usePlay } from "./Play";
import "./App.css";

export default function Rolette() {
  console.log("Rolette rendered==========", sessionStorage.getItem("balance"));
  const [mustSpin, setMustSpin] = useState(false);
  const [type, setType] = useState(0);
  const { prizeNumber, setPrizeNumber, data } = usePlay();
  var ball = sessionStorage.getItem("balance");
  // const [balance2, setBalance2] = useState(ball);
  console.log("balance2==========", ball);
  const profile2 = sessionStorage.getItem("name");
  console.log("profile222", profile2);
  if (profile2 == null) {
    console.log("profile2 == null");
    ball = 0;
  }
  const handleSpinClick = () => {
    const newPrizeNumber = Math.floor(Math.random() * data.length);
    setPrizeNumber(newPrizeNumber);
    console.log("111mustSpinmustSpinmustSpinmustSpinmustSpin ", mustSpin);
    setMustSpin(true);
    console.log("222mustSpinmustSpinmustSpinmustSpinmustSpin ", mustSpin);

    if (type === 0) {
      alert("Select a valid game type!!");
    } else if (type === "red") {
      betOnRedColor2(newPrizeNumber);
    } else if (type === "black") {
      betOnBlackColor2(newPrizeNumber);
    } else if (type === "betonnumber") {
      betOnNumber2(newPrizeNumber);
    }
    console.log("333mustSpinmustSpinmustSpinmustSpinmustSpin ", mustSpin);
  };

  function betOnRedColor() {
    console.log("betOnRedColor======");
    setType("red");
    document.getElementById("betonnumber").value = "";
    document.getElementById("winchance").value = 47.36;
    // document.getElementById("multiplier").value = 2;
    document.getElementById("winningamount").value =
      document.getElementById("multiplier").value *
      document.getElementById("bettingamount").value;
  }

  function betOnRedColor2(newPrizeNumber) {
    console.log("betoncolor:::", newPrizeNumber);
    if (newPrizeNumber % 2 == 0) {
      document.getElementById("balance").value =
        Number(document.getElementById("winningamount").value) +
        Number(document.getElementById("balance").value);
      sessionStorage.setItem(
        "balance",
        document.getElementById("balance").value
      );
      setTimeout(
        () => {
          alert("Output Number: " + newPrizeNumber + " \nYou Won!");
        },
        12000,
        newPrizeNumber
      );
    } else {
      document.getElementById("balance").value =
        Number(document.getElementById("balance").value) -
        Number(document.getElementById("winningamount").value);
      sessionStorage.setItem(
        "balance",
        document.getElementById("balance").value
      );
      setTimeout(
        () => {
          alert("Output Number: " + newPrizeNumber + " \nYou Lost!");
        },
        12000,
        newPrizeNumber
      );
      // if (!mustSpin) alert("Output Number: " + newPrizeNumber + "\n You Lost!");
    }
  }

  function betOnBlackColor() {
    console.log("betOnBlackColor======");
    setType("black");
    document.getElementById("betonnumber").value = "";
    document.getElementById("winchance").value = 47.36;
    // document.getElementById("multiplier").value = 2;
    document.getElementById("winningamount").value =
      document.getElementById("multiplier").value *
      document.getElementById("bettingamount").value;
  }

  function betOnBlackColor2(newPrizeNumber) {
    console.log("betoncolor:::", newPrizeNumber);
    if (newPrizeNumber % 2 != 0) {
      document.getElementById("balance").value =
        Number(document.getElementById("winningamount").value) +
        Number(document.getElementById("balance").value);
      sessionStorage.setItem(
        "balance",
        document.getElementById("balance").value
      );
      setTimeout(
        () => {
          alert("Output Number: " + newPrizeNumber + " \nYou Won!");
        },
        12000,
        newPrizeNumber
      );
    } else {
      document.getElementById("balance").value =
        Number(document.getElementById("balance").value) -
        Number(document.getElementById("winningamount").value);
      sessionStorage.setItem(
        "balance",
        document.getElementById("balance").value
      );
      setTimeout(
        () => {
          alert("Output Number: " + newPrizeNumber + " \nYou Lost!");
        },
        12000,
        newPrizeNumber
      );
    }
  }

  // function betOnBlackColor() {}

  function betOnNumber() {
    console.log("betOnBlackColor======");
    setType("betonnumber");
    document.getElementById("winchance").value = 2.63;
    // document.getElementById("multiplier").value = 2;
    document.getElementById("winningamount").value =
      document.getElementById("multiplier").value *
      document.getElementById("bettingamount").value;
  }
  function betOnNumber2(newPrizeNumber) {
    const numm = document.getElementById("betonnumber").value;
    if (numm === newPrizeNumber) {
      document.getElementById("balance").value =
        Number(document.getElementById("winningamount").value) +
        Number(document.getElementById("balance").value);
      sessionStorage.setItem(
        "balance",
        document.getElementById("balance").value
      );
      setTimeout(
        () => {
          alert("Output Number: " + newPrizeNumber + " \nYou Won!");
        },
        12000,
        newPrizeNumber
      );
    } else {
      document.getElementById("balance").value =
        Number(document.getElementById("balance").value) -
        Number(document.getElementById("winningamount").value);
      sessionStorage.setItem(
        "balance",
        document.getElementById("balance").value
      );
      setTimeout(
        () => {
          alert("Output Number: " + newPrizeNumber + " \nYou Lost!");
        },
        12000,
        newPrizeNumber
      );
    }
  }
  // function betOnOdd() {}
  // function betOnEven() {}

  // document.getElementById("balance").value = balance2;

  return (
    <>
      <div align="center" className="weel">
        <hr />
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={data}
          outerBorderColor={["#f2f2f2"]}
          outerBorderWidth={[5]}
          innerBorderColor={["#f2f2f2"]}
          radiusLineColor={["#dedede"]}
          radiusLineWidth={[2]}
          textColors={["#ffffff"]}
          fontSize={[20]}
          perpendicularText={[true]}
          innerRadius={[60]}
          textDistance={[85]}
          backgroundColors={["red", "black"]}
          onStopSpinning={() => {
            setMustSpin(false);
          }}
        />

        <hr />
        <div className="grid-container">
          <div className="grid-item">
            <label for="balance">Balance</label>
            <input type="text" id="balance" name="balance" value={ball}></input>
          </div>
          <div className="grid-item">
            <button className="button2 mybtn" onClick={handleSpinClick}>
              SPIN
            </button>
            {/* <br /> */}
            {!mustSpin ? data[prizeNumber].option : "0"}
          </div>
          <div className="grid-item">
            <label for="winchance">Win Chance</label>
            <input type="text" id="winchance" name="winchance"></input>
          </div>
          <div className="grid-item">
            <label for="multiplier">Multiplier</label>
            <input type="text" id="multiplier" name="multiplier"></input>
          </div>
          <div className="grid-item">
            <label for="bettingamount">Betting Amount</label>
            <input type="text" id="bettingamount" name="bettingamount"></input>
          </div>
          <div className="grid-item">
            <label for="winningamount">Winning Amount</label>
            <input type="text" id="winningamount" name="winningamount"></input>
          </div>
          <div className="grid-item">
            <label for="winningamount">Bet on Color</label>
            <button className="red mybtn" onClick={betOnRedColor}>
              RED
            </button>
            <button className="black mybtn" onClick={betOnBlackColor}>
              BLACK
            </button>
          </div>
          <div className="grid-item">
            <button className="black mybtn" onClick={betOnNumber}>
              Bet on Number
            </button>
            <input type="text" id="betonnumber" name="betonnumber"></input>
          </div>
          <div className="grid-item">
            <label for="winningamount">Bet Odd or Even</label>
            <button className="odd mybtn" onClick={betOnBlackColor}>
              ODD
            </button>
            <button className="even mybtn" onClick={betOnRedColor}>
              EVEN
            </button>
          </div>
        </div>

        {/* <Content></Content> */}
      </div>
    </>
  );
}
